var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWhiteRightArrow = function SvgWhiteRightArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.959 11.967a1.405 1.405 0 0 0 0-1.945L13.28 3.149a1.311 1.311 0 0 0-1.89 0 1.405 1.405 0 0 0 0 1.946l4.403 4.527H2.986c-.739 0-1.336.615-1.336 1.375s.597 1.374 1.336 1.374H15.79l-4.396 4.527a1.405 1.405 0 0 0 0 1.946c.522.537 1.37.537 1.891 0l6.68-6.872-.005-.005Z",
    fill: "#fff"
  })));
};
export default SvgWhiteRightArrow;